export const isProductNumberEqual = (agreements, agreement) => agreements.some(item => (
  item.productNumber === agreement.productNumber
  && item.productType === agreement.productType
  && item.agreementNumber !== agreement.agreementNumber
));
